import {
  Collection,
  Button,
  Card,
  ScrollView,
  SearchField,
  Loader,
} from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

export const ItemListCollection = ({
  items = [],
  selectedItems = [],
  setSelectedItems,
  onSearchSubmit,
  orderBy,
  loading = false,
}) => {
  const onSelectItem = (item) => {
    setSelectedItems((prevSt) => [...prevSt, item]);
  };

  const onDeselectItem = (item) => {
    setSelectedItems((prevSt) => prevSt.filter((p) => p.id !== item.id));
  };

  return (
    <Card borderRadius="medium" maxHeight="30rem" variation="outlined">
      <SearchField
        label="Search"
        className="mb-2"
        placeholder={strings.search.placeholder}
        onSubmit={onSearchSubmit}
        onClear={onSearchSubmit}
      />
      {loading ? (
        <Loader />
      ) : (
        <ScrollView height="24rem">
          <Collection
            type="list"
            direction="column"
            gap="10px"
            wrap="wrap"
            items={
              orderBy === "ASC"
                ? items?.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                  })
                : orderBy === "DESC"
                ? items?.sort((a, b) => {
                    return b.name.localeCompare(a.name);
                  })
                : items
            }
            searchNoResultsFound={
              <div className="text-center">{strings.search.noResults}</div>
            }
          >
            {(item) => (
              <Button
                style={{ marginRight: "10px" }}
                variation={
                  selectedItems.some((sel) => sel.id === item.id)
                    ? "primary"
                    : ""
                }
                grow="1"
                key={item.id}
                onClick={() =>
                  selectedItems.some((sel) => sel.id === item.id)
                    ? onDeselectItem(item)
                    : onSelectItem(item)
                }
              >
                {item.name}
              </Button>
            )}
          </Collection>
        </ScrollView>
      )}
    </Card>
  );
};

const strings = new LocalizedStrings({
  es: {
    search: {
      placeholder: "Buscar...",
      noResults: "No hay resultados",
    },
  },
});

export default ItemListCollection;
